<template>
  <div>
    <div v-if="viewIndex === 0" class="card">
      欢迎开通 51卡 订阅会员
    </div>

    <div v-if="viewIndex === 0" class="card-content">
      <div class="card-item">
        <div class="text-lg text-bold margin-bottom-lg text-left">收费标准</div>
        <a-image :preview="false" :src="require('@/assets/card/shoufei.png')" :height="150"/>
        <div class="margin-top">
          <div class="text-bold flex">$11.99/1年 0月费</div>
          <div class="text-df flex margin-top-xs">
            <div class="margin-right-xs">充值手续费 3.5%</div>
            <div>提现手续费 0%</div>
          </div>
          <div class="text-df flex margin-top-xs">
            <div class="margin-right-xs">消费手续费 0%</div>
            <div>退款手续费 0%</div>
          </div>
          <div class="text-df flex margin-top-xs">非美国消费 1%+$0.3</div>
        </div>
      </div>
      <div class="card-item">
        <div class="text-lg text-bold margin-bottom-lg text-left">会员权益</div>
        <a-image :preview="false" :src="require('@/assets/card/huiyuan.png')" :height="150"/>
        <div class="margin-top">
          <div class="text-bold flex">贴心客服服务</div>
          <div class="text-df flex margin-top-xs">
            赠送 51卡 订阅卡 1 张
          </div>
        </div>
      </div>
      <div class="card-item">
        <div class="text-lg text-bold margin-bottom-lg text-left">服务承诺</div>
        <a-image :preview="false" :src="require('@/assets/card/ser.png')" :height="150"/>
        <div class="margin-top">
          <div class="text-bold flex">订阅不成功全额退款</div>
          <div class="text-df flex margin-top-xs">
            支持全自动订阅
          </div>
        </div>
      </div>
      <div class="card-item">
        <div class="text-lg text-bold margin-bottom-lg text-left">注意事项</div>
        <a-image :preview="false" :src="require('@/assets/card/zhuyi.png')" :height="150"/>
        <div class="margin-top">
          <div class="text-bold flex">余额为0无法消费<span class="text-red">(强制扣款除外)</span></div>
          <div class="text-df flex margin-top-xs">
            <div class="margin-right-xs">余额不足消费失败3次会被冻结或删卡</div>
          </div>
          <div class="text-df flex margin-top-xs">
            <div class="margin-right-xs">需要支付费用解冻/换卡</div>
          </div>
          <div class="text-df flex margin-top-xs">注销不会退回会员费</div>
        </div>
      </div>
    </div>

    <div v-if="viewIndex === 0" class="flex justify-center align-items-center padding-lg">
      <div class="open global-btn" @click="viewIndex = 1">
        开通会员
      </div>
    </div>

    <div v-if="viewIndex > 0" class="card-content-open">
      <div v-if="viewIndex === 1">
        <h1>重要服务说明</h1>
        <div class="text-left padding-xl margin-bottom-xl-l">
          <h3>报销须知：
            我们提供标准的国际商业发票(Invoice)和收据(Receipt)。无法提供中国标准的发票。如您需要进行国内报销，请在订购服务前充分考虑此项限制。</h3>
          <h3>网络访问： 我们不提供 ChatGPT/Claude 等 AI
            平台的网络接入方案。若您所在地区无法正常访问这些服务，请在订购前确认您具备必要的网络环境。</h3>
          <h3>Claude 注册： 我们已停止提供基于海外手机号的 Claude 注册服务。如果您订购是为了注册 Claude
            账号，请知悉我们不再提供此项服务。</h3>
        </div>
      </div>

      <div class="card-content-open" v-if="viewIndex === 2">
        <h1>填写信息</h1>
        <div class="padding-xl flex justify-center align-items-center margin-bottom-xl-l">
          <a-image :preview="false" :src="require('@/assets/card/cardinput.png')" :height="320"/>
          <div>
            <a-form ref="formRef" :model="cardData" layout="vertical">
              <a-form-item hide-asterisk hide-label validate-trigger="input" field="firstName" label=""
                           :rules="[{required:true,message:'请输入姓名'}]">
                <div>
                  <div class="margin-bottom-xs text-left">拼音 姓</div>
                  <a-input class="input-cell input-cell-name" v-model="cardData.firstName" @input="handleInputFirstName"
                           placeholder="Zhang" allow-clear/>
                </div>
                <div class="margin-left">
                  <div class="margin-bottom-xs text-left">拼音 名</div>
                  <a-input class="input-cell input-cell-name" v-model="cardData.lastName" @input="handleInputLastName"
                           placeholder="san" allow-clear/>
                </div>
              </a-form-item>
              <a-form-item hide-asterisk field="email" validate-trigger="input" label="邮箱"
                           :rules="[{required:true,message:'请输入邮箱'},{ type: 'email', message:'请输入正确邮箱', required: true}]">
                <a-input class="input-cell" v-model="cardData.email" @input="handleInputEmail" placeholder="请输入邮箱"
                         allow-clear/>
              </a-form-item>
              <a-form-item hide-asterisk field="phone" validate-trigger="input" label="手机号"
                           :rules="[{required:true,message:'请输入手机号'},{validator: checkPhoneValid, message: '请输入正确手机号' }]">
                <a-input class="input-cell" v-model="cardData.phone" @input="handleInputPhone"
                         placeholder="请输入手机号" allow-clear>
                  <template #prefix>
                    <Vue3CountryIntl
                        schema="popover"
                        selectedText="已选中"
                        :useChinese="true"
                        :iso2="cardData.iso2"
                        searchInputPlaceholder="输入国家或者区号搜索"
                        v-model="cardData.countryCode"
                        v-model:visible="countryView"
                        @change="changeCountry">
                      <Vue3CountryFlag :value="cardData.iso2"
                                       :iso2="cardData.iso2"
                                       class="cursor-pointer"
                                       @click="countryView = true">
                        <template v-slot="{country}">
                          <span style="margin-left: 3px;">{{ '+' + country.dialCode }}</span>
                        </template>
                      </Vue3CountryFlag>
                    </Vue3CountryIntl>
                    <a-divider direction="vertical"/>
                  </template>
                </a-input>
              </a-form-item>
            </a-form>
          </div>
        </div>
      </div>

      <div class="card-content-open" v-if="viewIndex === 3">
        <h1>申请结果</h1>
        <div class="padding-xl margin-bottom-xl-l" v-if="cardData.auditStatus === 0">
          <h3>您的申请已提交,客服会在24小时之内审核...</h3>
        </div>
        <div class="padding-xl margin-bottom-xl-l" v-if="cardData.auditStatus === 2">
          <h3>审核失败, 原因: <span class="text-red">{{ cardData.auditCause }}</span></h3>
        </div>
      </div>

      <a-card title="我的卡片" class="card-content-open" v-if="viewIndex === 4">
        <div style="width: 100%;" class="flex justify-center align-center">
          <h1 class="open-copy global-btn">
            卡余额:
            <div class="text-red margin-left-sm"> $ {{ Number(cardDataInfo.balance?.available || 0).toFixed(2) }}</div>
          </h1>
        </div>

        <div class="margin-bottom-lg flex justify-center align-items-center">
          <div class="position-relative" style="width: 664px;height: 428px;">
            <a-image v-if="!showFront" style="border-radius: 16px;" :width="664" :height="428"
                     :src="require('@/assets/ucards/cards_f.png')" :preview="false">
            </a-image>
            <div class="position-absolute" style="top: 10px;right: 30px;">
              <IconEyeInvisible class="text-white global-btn text-sl cursor-pointer"
                                style="color: white !important;" @click="queryIsPay"/>
            </div>
            <div v-if="showFront" class="position-relative">
              <a-image style="border-radius: 16px;" :width="664" :height="428"
                       :src="require('@/assets/ucards/cards_b.png')" :preview="false"/>
              <div class="position-absolute" style="top: 10px;right: 30px;">
                <IconEye class="text-white global-btn text-sl cursor-pointer"
                         style="color: white !important;" @click="queryIsPay"/>
              </div>
              <div class="position-absolute text-white text-left"
                   style="top: 62px;left: 20px;width: 100%;height: 100%;">
                <div class="text-xsl">{{ cardBackInfo.cardNo ? cardBackInfo.cardNo : '' }}</div>
              </div>
              <div class="position-absolute text-white" style="bottom: 60px;left: 20px;width: 100%;">
                <div class="flex text-xxl text-left">
                  <div>
                    <div>{{ cardBackInfo.firstName ? cardBackInfo.firstName : '' }}</div>
                    <div>{{ cardBackInfo.lastName ? cardBackInfo.lastName : '' }}</div>
                    <div class="text-gray margin-top-xs">Name</div>
                  </div>
                </div>
              </div>
              <div class="position-absolute text-white" style="bottom: 60px;left: 350px;width: 100%;">
                <div class="flex text-xxl text-left">
                  <div>
                    <div>{{
                        (cardBackInfo.expMonth ? cardBackInfo.expMonth : '') + '/' + (cardBackInfo.expYear ? cardBackInfo.expYear : '')
                      }}
                    </div>
                    <div class="text-gray margin-top-xs">VALID THRU</div>
                  </div>
                </div>
              </div>
              <div class="position-absolute text-white" style="bottom: 60px;left: 560px;width: 100%;">
                <div class="flex text-xxl text-left">
                  <div>
                    <div>{{ cardBackInfo.cvv ? cardBackInfo.cvv : '' }}</div>
                    <div class="text-gray margin-top-xs">CVV</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </a-card>

      <a-card title="交易记录" class="card-content-open" v-if="viewIndex === 4">
        <a-table :pagination="false" :loading="loading" :columns="columns" :data="transferList">
          <template #columns>
            <a-table-column title="交易时间" data-index="orderTime">
              <template #cell="{ record }">
                <div class="text-blue">{{ record.orderTime }}</div>
              </template>
            </a-table-column>

            <a-table-column title="交易ID" data-index="orderNo">
              <template #cell="{ record }">
                <div class="text-gray">{{ record.orderNo }}</div>
              </template>
            </a-table-column>

            <a-table-column title="交易类型" data-index="orderType">
              <template #cell="{ record }">
                <div class="text-bold" :class="record.orderType === 'TransferOut' ? 'text-gray' : 'text-green'">
                  {{
                    record.orderType === 'TransferOut' ? '转出' : record.orderType === 'Fee_Consumption' ? '交易授权费用' : record.orderType === 'Consumption' ? '消费支出' :
                        record.orderType === 'TransferIn' ? '充值' : record.orderType === 'Declined_Fee' ? '交易失败费' : record.orderType === 'Credit' ? '交易退款' :
                            record.orderType === 'Reversal' ? '交易撤销' : '---'
                  }}
                </div>
              </template>
            </a-table-column>

            <a-table-column title="交易金额($)" data-index="orderAmount">
              <template #cell="{ record }">
                <div class="text-red text-bold">
                  {{ record.orderAmount ? record.orderAmount : '0.00' }}
                </div>
              </template>
            </a-table-column>

            <a-table-column title="原币种金额" data-index="currencyAmount">
              <template #cell="{ record }">
                <div class="text-gray">
                  {{ record.currencyAmount ? record.currencyAmount : '-' }}
                </div>
              </template>
            </a-table-column>

            <a-table-column title="手续费($)" data-index="orderFee">
              <template #cell="{ record }">
                <div class="text-gray">
                  {{ record.orderFee ? record.orderFee : '-' }}
                </div>
              </template>
            </a-table-column>

            <a-table-column title="交易状态" data-index="orderStatus">
              <template #cell="{ record }">
                <div class="text-bold" :class="record.orderStatus === 'Closed' ? 'text-green' : 'text-red'">
                  {{
                    record.orderStatus === 'Closed' ? '已完成' : record.orderStatus === 'Pending' ? '处理中' : record.orderStatus === 'Fail' ? '交易失败' : '---'
                  }}
                </div>
              </template>
            </a-table-column>
          </template>
        </a-table>
        <!-- 分页 -->
        <div class="page-size margin-top margin-bottom-lg" v-if="transferList && transferList.length > 0">
          <a-pagination :page-size="limit" :total="total" show-less-items @change="changePageNum"
                        :show-size-changer="false"
                        @page-size-change="changePageSize"/>
        </div>
      </a-card>

      <div class="bottom-png" v-if="viewIndex < 4">
        <div class="global-btn open-bg-white margin-right" @click="cancel">
          {{ viewIndex === 3 ? '返回' : '取消' }}
        </div>

        <div v-if="viewIndex === 3 && cardData.auditStatus === 2" class="open global-btn"
             @click="restartSubmit">
          重新提交
        </div>

        <div v-if="viewIndex === 2" class="open global-btn" @click="handleSubmit">
          下一步
        </div>
        <div v-if="viewIndex === 0 || viewIndex === 1" class="open global-btn" @click="viewIndex += viewIndex">
          下一步
        </div>
      </div>
    </div>

<!--    <a-modal v-model:visible="showPay" top="140px" ok-text="已支付">-->
<!--      <template #title>-->
<!--        选择服务年限支付-->
<!--      </template>-->
<!--      <div class="padding flex flex-direction justify-center align-center">-->
<!--        <div class="margin-bottom-lg flex justify-center align-center">-->
<!--          <a-image :src="require('@/assets/img_1.png')" :preview="false" width="328px" height="328px"></a-image>-->
<!--        </div>-->
<!--        <div>-->
<!--          <div class="checkSelected margin-bottom cursor-pointer" :class="{'checkSelected-selected': selectIndex === 1}"-->
<!--               @click="selectIndex = 1">-->
<!--            <div>2年</div>-->
<!--            <div>$16.99</div>-->
<!--          </div>-->
<!--          <div class="checkSelected cursor-pointer" :class="{'checkSelected-selected': selectIndex === 2}"-->
<!--               @click="selectIndex = 2">-->
<!--            <div>1年</div>-->
<!--            <div>$11.99</div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="padding-sm margin-bottom-xs">-->
<!--          <div class="text-bold text-xl">须知</div>-->
<!--          <div class="margin-top-xs">· 您所支付的费用为服务费，支付后不会转入账户余额。</div>-->
<!--          <div class="margin-top-xs">· 因余额不足消费失败累计达到 3 次后，卡片将触发银行风控自动删除，如需继续使用可支付-->
<!--            1.49-->
<!--            美金开新卡-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </a-modal>-->
  </div>
</template>

<script>
import Vue3CountryIntl from 'vue3-country-intl';
import {cardBackInfo, cardNoInfo, checkPhone, create, isCreate, cardTransactions} from "@/api/user";
import {IconEye, IconEyeInvisible} from '@arco-design/web-vue/es/icon';

export default {
  name: 'Card',
  components: {Vue3CountryIntl, IconEye, IconEyeInvisible},
  data() {
    return {
      viewIndex: 0,
      countryView: false,
      cardData: {
        iso2: 'us',
        countryCode: '1',
        phone: '',
        email: '',
        firstName: '',
        lastName: '',
        showPay: false,
      },
      cardDataInfo: {},
      userInfo: {},
      cardBackInfo: {
        cardNo: '',
        firstName: '',
        lastName: '',
        expMonth: '',
        expYear: '',
        cvv: '',
      },
      showFront: false,
      isPay: false,
      showPay: false,
      selectIndex: 2,
      transferList: [],
      page: 1,
      limit: 10,
      total: 0,
      loading: false,
      columns: [
        {
          title: '交易时间',
          key: 'orderTime',
          align: 'center'
        },
        {
          title: '交易ID',
          key: 'orderNo',
          align: 'center'
        },
        {
          title: '类型',
          key: 'orderType',
          align: 'center'
        },
        {
          title: '交易金额($)',
          key: 'orderAmount',
          align: 'center'
        },
        {
          title: '原币种金额',
          key: 'currencyAmount',
          align: 'center'
        },
        {
          title: '手续费($)',
          key: 'orderFee',
          align: 'center'
        },
        {
          title: '交易状态',
          key: 'orderStatus',
          align: 'center'
        },
      ],
    }
  },
  created() {
    if (!this.$store.getters.token) {
      return this.$router.push('/')
    }
    let user = localStorage.getItem('USER_INFO')
    if (user) {
      this.userInfo = JSON.parse(user)
    }
    this.cardIsCreate()
  },
  methods: {
    // 分页 修改页码
    changePageNum(val) {
      this.page = val
      this.queryTransList()
    },
    // 分页 修改页数
    changePageSize(val) {
      this.page = 1
      this.limit = val
      this.queryTransList()
    },
    queryTransList() {
      this.loading = true
      let param = {
        page: this.page,
        limit: this.limit
      }
      cardTransactions(param, this.cardData.id)
          .then(res => {
            if (res.code === 200) {
              this.total = res.data.total
              this.transferList = res.data.list
              this.loading = false
            } else {
              this.loading = false
            }
          })
    },
    queryIsPay() {
      if (this.cardData.showPay) {
        if (this.showFront) {
          this.showFront = false
        } else {
          this.queryCardBackInfo()
        }
      } else {
        this.showPay = true
      }
    },
    handleView() {
      // this.showFront = !this.showFront
    },
    handleCopy() {
      // this.queryCardBackInfo()
    },
    queryCardBackInfo() {
      cardBackInfo()
          .then(res => {
            if (res.code === 200) {
              this.cardBackInfo = res.data
              if (this.cardBackInfo) {
                this.cardBackInfo.cardNo = this.cardBackInfo.cardNo.replace(/(.{4})(?=.)/g, '$1 ').trim()
                this.cardBackInfo.expYear = this.cardBackInfo.expYear.slice(-2)
              }
              this.showFront = true
            } else {
              this.showFront = false
            }
          })
    },
    handleInputEmail(v) {
      this.cardData.email = v.replace(/[^a-zA-Z0-9@._%+-]/g, "");
    },
    handleInputPhone(v) {
      this.cardData.phone = v.replace(/\D/g, "");
    },
    handleInputFirstName(v) {
      this.cardData.firstName = v.replace(/[^a-zA-Z]/g, "");
    },
    handleInputLastName(v) {
      this.cardData.lastName = v.replace(/[^a-zA-Z]/g, "");
    },
    cancel() {
      if (this.viewIndex === 3) {
        this.$router.push('/')
      } else {
        this.viewIndex = 0;
      }
    },
    cardIsCreate() {
      isCreate()
          .then(res => {
            if (res.code === 200) {
              if (res.data) {
                this.auditStatus = res.data.auditStatus
                this.cardData = res.data
                if (this.cardData.auditStatus === 0 || this.cardData.auditStatus === 2) {
                  this.viewIndex = 3
                  if (!this.cardData.showPay) {
                    this.showPay = true
                  }
                }
                if (this.cardData.auditStatus === 1) {
                  this.viewIndex = 4
                  if (!this.cardData.showPay) {
                    this.showPay = true
                  } else {
                    cardNoInfo(this.cardData.id).then(resCardInfo => {
                      this.cardDataInfo = resCardInfo.data
                      this.queryTransList()
                    })
                  }
                }
              }
            }
          }).catch(() => {
        // 这里不用再处理错误，错误已经在拦截器里处理了
      });
    },
    restartSubmit() {
      this.viewIndex = 2;
    },
    handleSubmit() {
      let that = this
      this.$refs.formRef.validate().then(result => {
        if (!result) {
          create(this.cardData)
              .then(res => {
                if (res.code === 200) {
                  this.viewIndex = 3
                  that.cardIsCreate()
                }
              }).catch(() => {
            // 这里不用再处理错误，错误已经在拦截器里处理了
          });
        }
      }).catch(() => {
        // 这里不用再处理错误，错误已经在拦截器里处理了
      });
    },
    changeCountry(event) {
      this.cardData.iso2 = event.iso2
      this.cardData.countryCode = event.dialCode
      this.checkPhoneSearch()
    },
    async checkPhoneValid(value, cb) {
      let isValid = true;
      await checkPhone({
        phone: value,
        countryCode: this.cardData.countryCode
      })
          .then(res => {
            if (res.code !== 200) {
              isValid = false
            }
          }).catch(() => {
            // 这里不用再处理错误，错误已经在拦截器里处理了
          });
      if (!isValid) {
        cb('请输入正确手机号')
      } else {
        cb()
      }
    },
    checkPhoneSearch() {
      let data = {
        phone: this.cardData.phone,
        countryCode: this.cardData.countryCode
      }
      checkPhone(data)
          .then(res => {
            if (res.code === 200) {
              return true
            } else {
              return false
            }
          }).catch(() => {
        // 这里不用再处理错误，错误已经在拦截器里处理了
      });
    },
  },
}

</script>

<style scoped>
.checkSelected {
  width: 340px;
  height: 50px;
  border-radius: 15px;
  border: 1px solid #cccccc;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
}

.checkSelected-selected {
  border: 1px solid #3A69FB;
}


.input-cell {
  width: 350px;
  height: 46px;
  border: 1px solid #ccc;
  border-radius: 14px;
  background-color: #fff;
}

:deep(.vue3-yn-country-flag .country-flag-img) {
  width: 30px;
}

.input-cell-name {
  width: 160px !important;
}

.bottom-png {
  display: flex;
  align-items: center;
  justify-content: center;

  position: absolute;
  bottom: 30px;
  margin: 0 auto;
  width: 100%;
}

.card-content-open {
  padding: 10px;
  height: 80%;
  margin: 40px 20px;
  background-color: #fff;
  border-radius: 15px;
  position: relative;
}

.open {
  padding-left: 60px;
  padding-right: 60px;
  background-color: #3189ef;
  height: 60px;
  color: white;
  font-size: 24px;
  border-radius: 15px;

  display: flex;
  align-items: center;
  justify-content: center;
}

.open-copy {
  background-color: #ffffff;
  height: 60px;
  color: #333333;
  font-size: 24px;
  border-radius: 15px;

  display: flex;
  align-items: center;
  justify-content: center;
}

.open-bg-white {
  padding-left: 60px;
  padding-right: 60px;
  background-color: white;
  height: 60px;
  color: gray;
  font-size: 24px;
  border-radius: 15px;
  border: 1px solid #cccccc;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card {
  padding: 80px 20px;
  font-size: 42px;
  font-weight: 500;
}

.card-content {
  padding: 40px 20px;
  display: flex;
  justify-content: space-around;
}

.card-item {
  width: 280px;
  height: 350px;
  background-color: white;
  border-radius: 10px;
  padding: 20px;
  margin-right: 20px;

}
</style>
